<template>
    <div class="card card-custom card-stretch">
        <!--begin::Header-->
        <div class="card-header border-0 pt-6">
            <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder font-size-h4 text-dark-75">{{ __('dashboard.disk.title') }}</span>
                <span class="text-muted mt-3 font-weight-bold font-size-lg">{{ __('general.past_7_days') }}</span>
            </h3>
            <div class="card-toolbar">
                <div class="font-weight-bolder font-size-h1 mt-n1 text-center"
                     :class="{
                    'text-danger': last + 25 >= 300,
                    'text-dark-75': last + 25 < 300
                }"
                >
                    {{ last }}Gb
                    <div class="font-size-sm text-muted mt-n2">{{ __('dashboard.disk.value') }}</div>
                </div>
            </div>
        </div>
        <!--end::Header-->
        <!--begin::Body-->
        <div class="card-body p-0 h-125px" style="position: relative;">
            <div ref="chart" class="card-rounded-bottom position-absolute bottom-0 w-100"
                 style="min-height: 120px;">
            </div>
            <div class="resize-triggers">
                <div class="expand-trigger">
                    <div style="width: 383px; height: 126px;"></div>
                </div>
                <div class="contract-trigger"></div>
            </div>
        </div>
        <!--end::Body-->
    </div>
</template>

<script>
export default {
    data() {
        return {
            last: '...',

        }
    },

    mounted() {
        let vue = this

        axios.get(this.$route('widget.server.storage')).then((response) => {
            let data = response.data

            this.last = data.values[data.values.length - 1]

            let options = {
                series: [
                    {
                        name: this.__('dashboard.disk.utilization'),
                        data: data.values,
                    },
                ],
                chart: {
                    type: 'area',
                    height: 120,
                    toolbar: {
                        show: false,
                    },
                    style: {
                        borderradiusbottom: '$card-border-radius',
                    },
                    zoom: {
                        enabled: false,
                    },
                    sparkline: {
                        enabled: true,
                    },
                },
                plotOptions: {},
                legend: {
                    show: false,
                },
                dataLabels: {
                    enabled: false,
                },
                fill: {
                    type: 'solid',
                    opacity: 1,
                },
                stroke: {
                    curve: 'smooth',
                    show: true,
                    width: 3,
                    colors: ['#B73C48'],
                },
                xaxis: {
                    categories: data.timestamps,
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                    },
                    labels: {
                        show: false,
                        style: {
                            colors: KTApp.getSettings()['colors']['gray']['gray-500'],
                            fontSize: '12px',
                            fontFamily: KTApp.getSettings()['font-family'],
                        },
                    },
                    crosshairs: {
                        show: false,
                        position: 'front',
                        stroke: {
                            color: KTApp.getSettings()['colors']['gray']['gray-300'],
                            width: 1,
                            dashArray: 3,
                        },
                    },
                },
                yaxis: {
                    min: 0,
                    labels: {
                        show: false,
                        style: {
                            colors: KTApp.getSettings()['colors']['gray']['gray-500'],
                            fontSize: '12px',
                            fontFamily: KTApp.getSettings()['font-family'],
                        },
                    },
                },
                states: {
                    normal: {
                        filter: {
                            type: 'none',
                            value: 0,
                        },
                    },
                    hover: {
                        filter: {
                            type: 'none',
                            value: 0,
                        },
                    },
                    active: {
                        allowMultipleDataPointsSelection: false,
                        filter: {
                            type: 'none',
                            value: 0,
                        },
                    },
                },
                tooltip: {
                    style: {
                        fontSize: '12px',
                        fontFamily: KTApp.getSettings()['font-family'],
                    },
                    x: {
                        formatter: function(i) {
                            let timestamp = data.timestamps[i];
                            return vue.$localDate(timestamp) + ', ' + vue.$localTime(timestamp)
                        },
                    },
                    y: {
                        formatter: function(val) {
                            return val + 'Gb'
                        },
                    },
                },
                colors: ['#f8e9ea'],
                markers: {
                    colors: ['#B73C48'],
                    strokeColor: ['#B73C48'],
                    strokeWidth: 3,
                },
            }

            let chart = new ApexCharts(this.$refs.chart, options)
            chart.render()
        })
    },
}
</script>
